import { request } from '@/plugins/plugin-request';
// 最近历史访问
export function getRecentHistory(params) {
  return request
    .get({
      url: 'common.getUserRecentVisit',
      params,
    })
    .then((res) => res.data);
}
// 业务线列表
export function getAllSideList(params) {
  return request
    .get({
      url: 'common.getServiceLineList',
      params,
    })
    .then((res) => res.data);
}
